// extracted by mini-css-extract-plugin
export default {"mainContent":"profile_mainContent__cQr2i","container":"profile_container__VpEZn"};